import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import axios from "axios";
import {Dropdown} from "primereact/dropdown";

const MetricsmeasureFormComponent = (props) => {

  //form
  const [formData, setFormData] = useState({
    metrics: window.App.state.propsMetrics.id,
    position:1
  });
  const [loading, setLoading] = useState(false);
  const [units, setUnits] = useState([]);
  const validate = (data) => {
    let errors = {};
    // if (!data.name) {
    //   errors.name = 'Az megnevezés nem lehet üres';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    setFormData({
      ...formData,
      data
    });
    const payload = {
      name: formData.name,
      unit: formData.unit,
      type: formData.type,
      metrics: formData.metrics,
      position: formData.position,
    }
    if (formData.id) {
      axios({
        method: 'put',
        url: process.env.REACT_APP_API_HOST + '/api/v2/metrics-measure/' + formData.id,
        data: payload,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
        .then(response => {
          window.App.toastShow('success', 'Sikeres módosítás!');
          window.App.setState({
            rerenderMetricsmeasureList: true,
            sidebarMetricsmeasureUpdate: false
          })
          if (window.App.state.dialogMetricsmeasureForm === true) {
            window.App.setState({dialogMetricsmeasureForm: false})
          }
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    } else {
      axios({
        method: 'post',
        url: process.env.REACT_APP_API_HOST + '/api/v2/metrics-measure',
        data: data,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({
            rerenderMetricsmeasureList: true,
            sidebarMetricsmeasureCreate: false
          })
          if (window.App.state.dialogMetricsmeasureForm === true) {
            window.App.setState({dialogMetricsmeasureForm: false})
          }
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  useEffect(() => {
    if (window.App.state.propsMetricsmeasure) {
        setLoading(true)
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_HOST + '/api/v2/metrics-measure/' + window.App.state.propsMetricsmeasure.id,
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
          .then(response => {
            setFormData(response.data.data)
            setLoading(false)
          })
          .catch(error => {
            window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
            setLoading(false)
          })
    }
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/unit", {
      headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
    })
      .then(response => {
        setUnits(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }, [])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit}) => (
      <form onSubmit={handleSubmit} className="">
        <Panel headerTemplate={
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-list"}></i> Alapadatok
              </h3>
            </div>
          </div>
        } className={""}>
          <div className={"p-grid"}>
            {/*<div className={"p-col-12 p-lg-2"}>*/}
            {/*  <Field name="active" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="active"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>Aktív</label>*/}
            {/*      <span className="p-d-block">*/}
            {/*        <InputSwitch*/}
            {/*          className={"p-mt-1"}*/}
            {/*          checked={formData.active}*/}
            {/*          value={formData.active}*/}
            {/*          onChange={e => setFormData({...formData, active: e.target.value})}/>*/}
            {/*      </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
            <div className={"p-col-12 p-lg-12 p-xl-12"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>Megnevezés</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-12 p-xl-12"}>
              <Field name="unit" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="unit"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>Mértékegység</label>
                  <span className="p-d-block">
                      {formData && formData.unit && formData.unit.id ? (
                        <Dropdown {...input}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      unit: {id: e.target.value}
                                    })
                                    localStorage.setItem("defaultUnitId", e.target.value)
                                  }}
                                  value={formData.unit.id}
                                  options={units}
                                  optionLabel="name"
                                  optionValue="id"
                                  id={"unit"}
                                  emptyMessage={"Még nincs egység..."}
                                  className={classNames({'p-error': isFormFieldValid(meta)})}
                        />
                      ) : (
                        <Dropdown {...input}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      unit: e.target.value
                                    })
                                    localStorage.setItem("defaultUnitId", e.target.value)
                                  }}
                                  options={units}
                                  optionLabel="name"
                                  optionValue="id"
                                  id={"unit"}
                                  emptyMessage={"Még nincs egység..."}
                                  className={classNames({'p-error': isFormFieldValid(meta)})}
                        />
                      )}
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-12 p-xl-12"}>
              <Field name="unit" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="unit"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>Típus</label>
                  <span className="p-d-block">
                        <Dropdown {...input}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      type: e.target.value
                                    })
                                  }}
                                  value={formData.type?.id || formData.type}
                                  options={[
                                    {name: 'int', id: 'int'},
                                    {name: 'string', id: 'string'},
                                  ]}
                                  optionLabel="name"
                                  optionValue="id"
                                  id={"type"}
                                  emptyMessage={"Még nincs típus..."}
                                  className={classNames({'p-error': isFormFieldValid(meta)})}
                        />

                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
              <Button type="submit" label="Mentés" icon={"pi pi-check"} loading={loading}
                      className="p-button-success"/>
            </div>
          </div>
        </Panel>
      </form>
    )}/>
  )
}
export default withTranslation('common')(MetricsmeasureFormComponent);
